import type { Metadata } from '@lumapps/metadata/types';
import type { MetadataReference } from '@lumapps/widget-base/types';

import type { MetadataMap, TranslateFn } from '../types';
import { findRootMetadata } from './findRootMetadata';

/**
 * Transforms an array of Metadata objects into the MetadataReference format
 *
 * @param metadataList - Array of Metadata objects from the API
 * @param metadataMap - Map from a metadata ID to a Metadata object for quick lookups
 * @param translate - Function to translate TranslateObject to string
 * @returns Array of MetadataReference objects
 */
export const transformMetadataToReferences = (
    metadataList: Metadata[],
    metadataMap: MetadataMap,
    translate: TranslateFn,
): MetadataReference[] => {
    return metadataList.map((metadata) => {
        const reference: MetadataReference = {
            metadataId: metadata.id,
            name: translate(metadata.name),
        };

        // If this metadata has a parent, find the root parent
        if (metadata.parent) {
            const rootMetadata = findRootMetadata(metadata, metadataMap);
            if (rootMetadata && rootMetadata.id !== metadata.id) {
                reference.rootId = rootMetadata.id;
                reference.rootName = translate(rootMetadata.name);
            }
        }

        return reference;
    });
};
